import { HistoryIcon, OverviewIcon, PauseIcon, PlayIcon } from "./Icons";

interface MobileDockProps {
  isPaused: boolean;
  historyOpen: boolean;
  onPause: () => void;
  onOverview: () => void;
  onHistory: () => void;
}

export function MobileDock({ isPaused, historyOpen, onPause, onOverview, onHistory }: MobileDockProps) {
  return (
    <div className="mobile-dock" role="group" aria-label="主要な表示操作">
      <button type="button" onClick={onPause} aria-describedby="pause-help">
        {isPaused ? <PlayIcon /> : <PauseIcon />}
        <span>{isPaused ? "RESUME" : "PAUSE"}</span>
      </button>
      <button type="button" onClick={onOverview}>
        <OverviewIcon />
        <span>OVERVIEW</span>
      </button>
      <button type="button" onClick={onHistory} aria-expanded={historyOpen} aria-controls="history-sheet-content">
        <HistoryIcon />
        <span>HISTORY</span>
      </button>
    </div>
  );
}
